import Vue from 'vue'
import Router from 'vue-router'
import { MessageBox } from 'element-ui'
import Frame from './views/Frame.vue'
import store from '@/store'
import storejs from 'store'
import c from '@/config'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Frame,
      redirect: { name: 'label' },
      children: [
        {
          path: 'label',
          name: 'label',
          component: () =>
            import(/* webpackChunkName: "label" */ './views/Label.vue'),
        },
        {
          path: 'review',
          name: 'review',
          component: () =>
            import(/* webpackChunkName: "review" */ './views/Review.vue'),
        },
        {
          path: 'history',
          name: 'history',
          component: () =>
            import(/* webpackChunkName: "history" */ './views/History.vue'),
        },
        {
          path: 'concat',
          name: 'concat',
          component: () =>
            import(/* webpackChunkName: "concat" */ './views/Concat.vue'),
        },
      ],
    },
    {
      path: '/forbidden',
      name: 'forbidden',
      component: () =>
        import(/* webpackChunkName: "forbidden" */ './views/Forbidden.vue'),
    },
  ],
})

function initPrivileges(to, from, next) {
  return new Promise((resolve, reject) => {
    store.dispatch('fetchPrivileges').then(privileges => {
      if (privileges === null) {
        alert('请先登陆')
        window.location.href = c.apiServer
        reject(new Error('请先登陆'))
        return
      }
      if (Object.keys(privileges).length === 0) {
        resolve({ name: 'forbidden' })
      } else if (to.name === 'forbidden') {
        resolve({ name: 'home' })
      } else {
        resolve()
      }
    })
  })
}

router.beforeEach((to, from, next) => {
  // load privileges
  if (store.state.privileges === null) {
    initPrivileges(to, from, next).then(routeTo => {
      if (store.state.clothAssessmentConfig) {
        next(routeTo)
      } else {
        Promise.all([
          store.dispatch('fetchClothAssessmentConfig'),
          store.dispatch('fetchUserInfo'),
        ]).then(resArr => {
          storejs.set('user', resArr[1])
          next(routeTo)
        })
      }
    })
  } else {
    if (store.state.modified) {
      MessageBox.confirm('修改未提交，确认离开？')
        .then(_ => {
          store.commit('setModify', false)
          next()
        })
        .catch(_ => {})
    } else {
      next()
    }
  }
})

window.onbeforeunload = function(e) {
  if (store.state.modified) {
    return true
  }
}

export default router
